// Browser tab title.
//
// The tab was a hardcoded "HIDENN SIM" in `public/index.html` — a name the app
// uses nowhere else (the dashboard wordmark says Dennis), and identical across
// every route, so several open projects were indistinguishable by their tabs.
//
// Project FIRST, brand second. A tab ellipsizes from the right at ~15-20
// characters, so the identifying half holds the visible left edge and it is
// "- Dennis" that gets cut — which is the half a user already knows. The full
// string stays available in the tab's hover tooltip.

import { useEffect } from 'react';

export const APP_NAME = 'Dennis';

/** `Heat sink v2 - Dennis`, or plain `Dennis` when no project is open. */
export function buildTitle(name) {
  const trimmed = String(name ?? '').trim();
  return trimmed ? `${trimmed} - ${APP_NAME}` : APP_NAME;
}

/**
 * Point the tab at `name` for as long as the calling component is mounted.
 *
 * The cleanup reset is what makes every non-project route fall back to the bare
 * app name without needing a title effect of its own — only `ProjectPage` has a
 * name to contribute, so only `ProjectPage` calls this.
 */
export function useDocumentTitle(name) {
  useEffect(() => {
    document.title = buildTitle(name);
    return () => {
      document.title = APP_NAME;
    };
  }, [name]);
}
